import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCouponStatus.ts
var t = () => e("couponStatus");
//#endregion
export { t as useTrCouponStatus };
